import axios from "axios";
// import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,

  // -----------------------------------------------------------------

  state: {
    endpoint: endpoints.online_cash_tx.endpoint, // "online-cash-tx",
    endpoints: endpoints.online_cash_tx.endpoints, // "online-cash-txs",
    endpointCancel: endpoints.online_cash_tx.endpointCancel, // "online-cash-tx-cancel",

    identifyEndpoint: endpoints.online_cash_tx.identifyEndpoint, // "oco-identify",
    depositEndpoint: endpoints.online_cash_tx.depositEndpoint, // "oco-deposit"
  },

  // -----------------------------------------------------------------

  getters: {
    endpoint: state => state.endpoint,
    endpoints: state => state.endpoints
  },

  // -----------------------------------------------------------------

  mutations: {},

  // -----------------------------------------------------------------

  actions: {
    fetch: (context, paginationData) => {
      const api =
        context.rootGetters["global/apiUrl"] + "/" + context.state.endpoints;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },

    read: (context, id) => {
      const api =
        context.rootGetters["global/apiUrl"] +
        "/" +
        context.state.endpoint +
        "/" +
        id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: "GET"
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },

    cancel: (context, data) => {
      const api =
        context.rootGetters["global/apiUrl"] +
        "/" +
        context.state.endpointCancel;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },

    identify: (context, { shop_id, cnp, phone }) => {
      const baseApiUrl = context.rootGetters["global/apiUrl"];
      const api = `${baseApiUrl}/${context.state.identifyEndpoint}`;
      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: { shop_id, cnp, phone: `004${phone}` },
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              resolve(r);
            } else {
              reject(r);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    deposit: (context, data) => {
      const apiEndpoint = context.rootGetters["global/apiUrl"];
      const api = `${apiEndpoint}/${context.state.depositEndpoint}`;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    }
  }
};
